import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65cf5d03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inventory" }

import { defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

defineComponent({
  name: 'InventoryView',
});

const route = useRoute();

const menus = [
  { title: 'Overview', to: 'overview' },
  { title: 'Carbon NFTs', to: 'carbon' },
  { title: 'Life NFTs', to: 'biodiversity' },
  { title: 'Carbon Tokens', to: 'carbon-token' },
  { title: 'Life Tokens', to: 'biodiversity-token' },
];
const initialActiveMenu = menus.findIndex((m) => route.path.includes(m.to));
const activeMenu = ref(initialActiveMenu);

return (_ctx: any,_cache: any) => {
  const _component_BaseTabs = _resolveComponent("BaseTabs")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_BaseBox = _resolveComponent("BaseBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseBox, {
      "box-style": "raised",
      padding: "flex flex-col px-6 py-2 space-y-6"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTabs, {
          modelValue: activeMenu.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeMenu).value = $event)),
          tabs: menus,
          class: "-mx-4 sm:mx-0",
          style: {"font-size":"18px"}
        }, null, 8, ["modelValue"]),
        _createVNode(_component_router_view)
      ]),
      _: 1
    })
  ]))
}
}

})